import { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';

const styles = {
  container: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'linear-gradient(135deg, #f8fafc 0%, #e0e7ff 100%)',
  },
  card: {
    background: '#fff',
    padding: '2.5rem 2rem',
    borderRadius: '1.25rem',
    boxShadow: '0 8px 32px rgba(60,72,100,0.12)',
    minWidth: 340,
    maxWidth: 360,
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  title: {
    fontSize: '1.5rem',
    fontWeight: 600,
    color: '#1f2937',
    marginBottom: '0.5rem',
    textAlign: 'center',
  },
  subtitle: {
    fontSize: '0.9rem',
    color: '#6b7280',
    marginBottom: '1.5rem',
    textAlign: 'center',
    lineHeight: 1.5,
  },
  input: {
    width: '100%',
    padding: '0.75rem',
    margin: '0.5rem 0',
    borderRadius: '0.5rem',
    border: '1px solid #e5e7eb',
    fontSize: '1rem',
    outline: 'none',
    transition: 'border 0.2s',
    boxSizing: 'border-box',
  },
  button: {
    width: '100%',
    padding: '0.75rem',
    margin: '1rem 0 0.5rem 0',
    borderRadius: '0.5rem',
    border: 'none',
    background: '#000000',
    color: '#fff',
    fontWeight: 600,
    fontSize: '1rem',
    cursor: 'pointer',
    transition: 'background 0.2s',
  },
  backLink: {
    color: '#6b7280',
    textDecoration: 'none',
    fontSize: '0.9rem',
    marginTop: '1rem',
    display: 'flex',
    alignItems: 'center',
    gap: '0.25rem',
  },
  error: {
    color: '#ef4444',
    fontSize: '0.95rem',
    marginTop: 4,
    textAlign: 'center',
  },
  success: {
    color: '#10b981',
    fontSize: '0.95rem',
    marginTop: 4,
    textAlign: 'center',
  },
};

export default function ForgotPassword() {
  const location = useLocation();
  const navigate = useNavigate();
  const [email, setEmail] = useState(location.state?.email || '');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!email) {
      setError('Please enter your email address.');
      return;
    }

    setLoading(true);
    try {
      const res = await fetch(`${API_URL}/api/event-invites/auth/forgot-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });

      await res.json();

      // Always navigate to verify code page (backend always returns success)
      navigate('/verify-code', { state: { email } });
    } catch (err) {
      setError('Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      <form style={styles.card} onSubmit={handleSubmit}>
        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '1rem' }}>
          <img
            src={require('../assets/top_logo.png')}
            alt="Invite Avenue Logo"
            style={{ width: '15vw', height: '20vh', objectFit: 'contain' }}
          />
        </div>
        <div style={styles.title}>Forgot password?</div>
        <div style={styles.subtitle}>
          Enter your email address and we'll send you a code to reset your password.
        </div>
        <input
          style={styles.input}
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          autoFocus={!email}
        />
        {error && <div style={styles.error}>{error}</div>}
        <button style={styles.button} type="submit" disabled={loading}>
          {loading ? 'Sending...' : 'Send reset code'}
        </button>
        <Link style={styles.backLink} to="/login">
          ← Back to login
        </Link>
      </form>
    </div>
  );
}
